import React from 'react';
import Icon from '../../../components/AppIcon';

const TrustSignalsCard = () => {
  const certifications = [
    {
      name: "ISO 27001",
      description: "Information Security Management",
      icon: "Shield"
    },
    {
      name: "AWS Certified",
      description: "Cloud Solutions Architecture",
      icon: "Cloud"
    },
    {
      name: "SOC 2 Type II",
      description: "Security & Availability",
      icon: "Lock"
    }
  ];

  const stats = [
    { label: "Projects Completed", value: "500+", icon: "CheckCircle" },
    { label: "Client Satisfaction", value: "98%", icon: "Star" },
    { label: "Years Experience", value: "12+", icon: "Calendar" },
    { label: "Team Members", value: "50+", icon: "Users" }
  ];

  return (
    <div className="space-y-6">
      {/* Security & Certifications */}
      <div className="bg-card border border-border rounded-lg p-6">
        <div className="flex items-center space-x-2 mb-4">
          <Icon name="Award" size={20} className="text-accent" />
          <h3 className="text-lg font-semibold text-card-foreground">Security & Certifications</h3>
        </div>
        
        <div className="space-y-3">
          {certifications?.map((cert, index) => (
            <div key={index} className="flex items-center space-x-3 p-3 bg-background/50 rounded-lg">
              <div className="w-10 h-10 bg-accent/10 rounded-lg flex items-center justify-center">
                <Icon name={cert?.icon} size={20} className="text-accent" />
              </div>
              <div>
                <p className="font-medium text-card-foreground text-sm">{cert?.name}</p>
                <p className="text-xs text-muted-foreground">{cert?.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* Company Stats */}
      <div className="bg-card border border-border rounded-lg p-6">
        <div className="flex items-center space-x-2 mb-4">
          <Icon name="TrendingUp" size={20} className="text-accent" />
          <h3 className="text-lg font-semibold text-card-foreground">Why Choose DARAJA.LABS</h3>
        </div>
        
        <div className="grid grid-cols-2 gap-4">
          {stats?.map((stat, index) => (
            <div key={index} className="text-center p-3 bg-background/50 rounded-lg">
              <Icon name={stat?.icon} size={24} className="text-accent mx-auto mb-2" />
              <p className="text-lg font-bold text-card-foreground">{stat?.value}</p>
              <p className="text-xs text-muted-foreground">{stat?.label}</p>
            </div>
          ))}
        </div>
      </div>
      {/* Process Overview */}
      <div className="bg-card border border-border rounded-lg p-6">
        <div className="flex items-center space-x-2 mb-4">
          <Icon name="GitBranch" size={20} className="text-accent" />
          <h3 className="text-lg font-semibold text-card-foreground">Our Process</h3>
        </div>
        
        <div className="space-y-3">
          <div className="flex items-start space-x-3">
            <div className="w-6 h-6 bg-accent rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
              <span className="text-accent-foreground text-xs font-bold">1</span>
            </div>
            <div>
              <p className="font-medium text-card-foreground text-sm">Application Review</p>
              <p className="text-xs text-muted-foreground">24-48 hour response time</p>
            </div>
          </div>
          
          <div className="flex items-start space-x-3">
            <div className="w-6 h-6 bg-accent rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
              <span className="text-accent-foreground text-xs font-bold">2</span>
            </div>
            <div>
              <p className="font-medium text-card-foreground text-sm">Discovery Call</p>
              <p className="text-xs text-muted-foreground">Detailed requirements discussion</p>
            </div>
          </div>
          
          <div className="flex items-start space-x-3">
            <div className="w-6 h-6 bg-accent rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
              <span className="text-accent-foreground text-xs font-bold">3</span>
            </div>
            <div>
              <p className="font-medium text-card-foreground text-sm">Proposal & Timeline</p>
              <p className="text-xs text-muted-foreground">Detailed project roadmap</p>
            </div>
          </div>
          
          <div className="flex items-start space-x-3">
            <div className="w-6 h-6 bg-accent rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
              <span className="text-accent-foreground text-xs font-bold">4</span>
            </div>
            <div>
              <p className="font-medium text-card-foreground text-sm">Project Kickoff</p>
              <p className="text-xs text-muted-foreground">Development begins</p>
            </div>
          </div>
        </div>
      </div>
      {/* Contact Information */}
      <div className="bg-card border border-border rounded-lg p-6">
        <div className="flex items-center space-x-2 mb-4">
          <Icon name="Phone" size={20} className="text-accent" />
          <h3 className="text-lg font-semibold text-card-foreground">Need Help?</h3>
        </div>
        
        <div className="space-y-3 text-sm">
          <div className="flex items-center space-x-2">
            <Icon name="Mail" size={16} className="text-accent" />
            <span className="text-muted-foreground">hello@daraja.labs</span>
          </div>
          <div className="flex items-center space-x-2">
            <Icon name="Phone" size={16} className="text-accent" />
            <span className="text-muted-foreground">+1 240-598-5442</span>
          </div>
          <div className="flex items-center space-x-2">
            <Icon name="MessageCircle" size={16} className="text-accent" />
            <span className="text-muted-foreground">Live chat available 9AM-6PM EST</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrustSignalsCard;